<template>
  <section>
    <v-card>
      <v-card-title class="chart-title" primary-title>
        {{ lessonTerm | capitalize }} Usage
      </v-card-title>
      <report-date-picker
        class="mx-3"
        :prop-date-from="dateFrom"
        :prop-date-to="dateTo"
        @dateToSelected="dateToSelected"
        @dateFromSelected="dateFromSelected"
      />
      <v-tabs v-model="tab" icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab key="chart">
          Chart
          <v-icon>bar_chart</v-icon>
        </v-tab>

        <v-tab key="table">
          Table
          <v-icon>table_chart</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="chart" class="pa-4">
          <bar-chart ref="chart" :chart-data="chartData" :options="options" />
        </v-tab-item>
        <v-tab-item key="table">
          <card-table :items="items" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import ReportDatePicker from '@/modules/client/views/reports/ReportDatePicker'
import ReportsMixin from '@/modules/client/views/reports/reports-mixin'
import BarChart from '../charts/BarChart'
import CardTable from '@/modules/client/views/dashboard/CardTable'
import { mapState } from 'vuex'

export default {
  components: {
    ReportDatePicker,
    BarChart,
    CardTable
  },
  mixins: [ReportsMixin],
  created() {
    this.dateFrom = this.$moment()
      .startOf('month')
      .format('YYYY-MM-DD')
  },
  async mounted() {
    this.type = 'usagePerLesson'
    this.items = await this.$axios.get(
      `api/clients/reports?type=${this.type}&date_start=${this.dateFrom}&date_end=${this.dateTo}`
    )
  },
  data() {
    return {
      tab: null,
      items: [],
      options: {
        animation: {
          duration: 500,
          easing: 'easeInOutSine'
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0
              }
            }
          ]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    headers() {
      return [
        {
          text: `${this.capitalizeFirstLetter(this.lessonTerm)}`,
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Count', align: 'center', sortable: true, value: 'count' }
      ]
    },
    chartData() {
      return {
        labels: this.items.map(i => i.name),
        datasets: [
          {
            label: `Number of completed ${this.lessonTerm}`,
            data: this.items.map(i => i.count),
            backgroundColor: this.$vuetify.theme.themes.light.primary
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
